import type { GetStaticPropsContext } from 'next'
import AnimalArchiveRoute, { getAnimalArchiveStaticProps } from '@/features/animal-archive/route'
import { makeStaticProps } from '@/lib/next'

export default AnimalArchiveRoute

type AnimalParams = {
  slug: string
}

export async function getStaticProps(ctx: GetStaticPropsContext) {
  const { locale, params } = ctx
  const animalPageParams = params as AnimalParams
  const props = await getAnimalArchiveStaticProps(animalPageParams.slug, locale)
  return makeStaticProps(props)
}

export function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}
